import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { CertificatDouane } from '../entity/certificat.douane';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError, tap } from 'rxjs/operators';
import { ResponseContentType, Http } from '@angular/http';
 

 
@Injectable({
  providedIn: 'root'
})
export class CertificatdouaneService {
  secteurs: CertificatDouane[];
  baseUrl = environment.restApi;

  certificatdouaneUrl = `${this.baseUrl}certificatdouane`;
  constructor(private http: HttpClient ) {

  }

  findByExhibitor(idClient: number): Observable<CertificatDouane[]> {
    //console.log("idClient" + idClient);

    return this.http
      .get<CertificatDouane[]>(`${this.certificatdouaneUrl}/findByClient/${idClient}`)
      .pipe(
        tap(_ => this.notify('fetched abstractEntities', 'GET')),
        catchError(this.handleError('getCertificatDouane', 'GET'))
      );
  }

  updateCertificatDouane(certificatDouane: CertificatDouane): Observable<any> {
    return this.http
        .put(`${this.certificatdouaneUrl}/${certificatDouane.id_certificat_douane}`, certificatDouane ) ;
}

addCertificatDouane(certificatDouane: CertificatDouane): Observable<CertificatDouane> {
 
  return this.http
      .post<CertificatDouane>(this.certificatdouaneUrl, certificatDouane, httpOptions)
      .pipe(
          tap((certificatDouane: CertificatDouane) => this.notify(`added CertificatDouane w/ id=${certificatDouane.id_certificat_douane}`, 'POST')),
          catchError(this.handleError('addCertificatDouane', 'POST'))
      );
}
deleteCertificatDouane(certificatDouane: CertificatDouane | number): Observable<any> {
  const id = typeof certificatDouane === 'number' ? certificatDouane : certificatDouane.id_certificat_douane;
  const url = `${this.certificatdouaneUrl}/${id}`;
  return this.http
      .delete<CertificatDouane>(url, httpOptions)
      .pipe(
          tap(_ => this.notify(`deleted certificatDouane id=${id}`, 'DELETE')),
          catchError(this.handleError('deleteCertificatDouane', 'DELETE'))
      );
}


printDouane(type:string,isSigner:boolean,isEntet:boolean,idDouane:number): any {
  // /{type}/{isSigner}/{isEntet}/{clientId}
  //console.log('isSigner'+isSigner);
  
          return this.http.put(this.certificatdouaneUrl + `/printDouane/${type}/${isSigner}/${isEntet}/${idDouane}`,  '', { responseType: "blob"})  ;
      }

  protected handleError(operation: string, method: string) {
    return function errorHandler(res: HttpErrorResponse) {
      this.logger.error(res);
      const eMsg = res.message || '';
      const error = `${this.entityNamePlural} ${operation} Error${
        eMsg ? ': ' + eMsg : ''
        }`;
      this.notify(error, method);
    }.bind(this);
  }

  protected notify(message: string, method: string) {
  }

}




const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};